"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const nestedContentEdit_1 = require("./nestedContentEdit");
exports.nestedContentEditOnBlocks = (blockOrBlocks) => {
    return blockOrBlocks.map(b => {
        return nestedContentEdit_1.nestedContentEdit(b);
    });
};
//# sourceMappingURL=nestedContentEditOnBlocks.js.map